export const getClockFromSeconds = (seconds: number) => {
  return {
    hour: Math.floor(seconds / 60 ** 2),
    minute: (seconds % 60 ** 2) / 60,
  }
}
